import AbstractMapper from '@core/utils/mappers/AbstractMapper';
import Message from '@core/models/user/messages/Message';
import IMessageDto from './dtos/IMessageDto';
import ActionMapper from './ActionMapper';

export default class MessageMapper extends AbstractMapper<IMessageDto, Message> {
    private actionMapper: ActionMapper = new ActionMapper();

    createTargetObject(obj: IMessageDto, options?: any) {
        return  {
            content: obj.Contents,
            title: obj.Title,
            actions: this.actionMapper.map(obj.Actions, true)
        } as Message;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/mappers/user/MessageMapper.ts